import { useUiStore } from '@/stores/ui';

export default defineNuxtPlugin(() => {
  const ui = useUiStore();
  const router = useRouter();

  router.beforeEach(() => {
    ui.setHeaderSkin(ui.headerSkinDefault);
  });
});
